import React from 'react'
import "./Footer.css";

function Footer() {
    return (
        <div className="footer">
            <div className="detail">
                <div className="table">
                    <div>
                        <div className="t-head">Get to Know Us</div>
                        <ul>
                            <li>Careers</li>
                            <li>Blogs</li>
                            <li>About Amazon</li>
                            <li>Investor Relations</li>
                            <li>Amazon Advices</li>
                            <li>Amazon Science</li>
                        </ul>
                    </div>

                    <div>
                        <div className="t-head">Make Money with Us</div>
                        <ul>
                            <li>Sell Products on Amazon</li>
                            <li>Sell on Amazon Business</li>
                            <li>Sell Apps on Amazon</li>
                            <li>Become an Affiliate</li>
                            <li>Advertise your Products</li>
                            <li>Host an Amazon Hub</li>
                        </ul>
                    </div>


                    <div>
                        <div className="t-head">Amazon Payment Products</div>
                        <ul>
                            <li>Amazon Business Cards</li>
                            <li>Shop with Points</li>
                            <li>Reload your Balance</li>
                            <li>Amazon Currency Converter</li>
                        </ul>
                    </div>


                    <div>
                        <div className="t-head">Let Us Help You</div>
                        <ul>
                            <li>Amazon and COVID-19</li>
                            <li>Your Account</li>
                            <li>Yoyr Orders</li>
                            <li>Shipping Rates and Policies</li>
                            <li>Returns and Replacements</li>
                            <li>Manage your Content & Devices</li>
                            <li>Amazon Assistant</li>
                            <li>Help</li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Footer
